<template>
  <div>
    <Nav />
    <!-- <Banner /> -->
    <div class="banners" >
      <div class="banners_content">
        <div class="banners_l">
          <div class="banners_title">星游聚</div>
          <div class="banners_desc">网络游戏全链路 AI智能体</div>
          <div class="banners_desc2">连接游戏开发者、广告平台与金融机构，提供数据洞察、智能投放、资产融资一站式服务平台，助力游戏企业实现全球化发展。</div>
          <div class="banners_btn">
            <div class="banners_btn1" @click="gourl('http://42.194.202.49/star-game/login')">立即免费体验</div>
            <div class="banners_btn2" @click="gourl('http://42.194.202.49/star-game/login')">了解更多</div>
          </div>
        </div>
        <img class="banner_z" style="width: 806px" src="../../assets/img/banner1.png" alt="" />
      </div>
    </div>

    <div class="advantage_content" id="a">
      <div class="ad_title">四大<span class="jb">核心优势</span></div>
      <div class="ad_desc">从数据洞察到资金支持，全方位赋能游戏开发者实现商业价值最大化，助力游戏企业腾飞</div>
      <div class="ad_list">
        <div
          v-for="(ad, idx) in adList"
          :key="idx"
          class="ad_item"
          @mouseenter="hoverAdIndex = idx"
          @mouseleave="hoverAdIndex = null"
        >
          <img
            style="width: 104px;margin-left: -18px;"
            :src="hoverAdIndex === idx ? ad.imgHover : ad.imgNormal"
            alt=""
          />
          <div class="ad_item_title">{{ ad.title }}</div>
          <div class="ad_item_desc">{{ ad.desc }}</div>
        </div>
      </div>
    </div>
    <!-- <ProductCarousel /> -->
    <div class="ai_content" id="b">
      <div class="ad_title">AI赋能<span class="jb2">创意无限</span></div>
      <div class="ad_desc">视频素材智能生成，酷炫图片一键创作，让内容生产更高效</div>
      <div class="ai_list">
        <div class="ai_item">
          <img class="ai_img" src="../../assets/img/ai1.png" alt="" />
          <div class="ai_item_title">视频素材智能生成</div>
          <div class="ai_item_desc">AI驱动的视频内容智造平台，支持宣传片、买量素材、过场动画的智能生产，多语言本地化与多平台适配一键完成</div>
          <div class="gouse" @click="gourl('http://42.194.202.49/star-game/login')">点击试用</div>
        </div>
        <div class="ai_item">
          <img class="ai_img" src="../../assets/img/ai2.png" alt="" />
          <div class="ai_item_title">酷炫图片创作</div>
          <div class="ai_item_desc">游戏美术AI工坊，覆盖角色设计、场景构建、UI元素等多维度美术需求，AI批量生成高质量游戏素材</div>
          <div class="gouse" @click="gourl('http://42.194.202.49/star-game/login')">点击试用</div>
        </div>
      </div>
    </div>

    <div class="com_content" id="c">
      <div class="ad_title">已助力<span class="jb2">100+</span>游戏企业</div>
      <div class="ad_desc">携手行业领先游戏公司，共同推动游戏产业智能化升级</div>
      <div class="com_list">
        <div
          v-for="(ad, idx) in comList"
          :key="idx"
          class="com_item"
        >
          <img
            style="width: 205px;"
            :src="ad.img"
            alt=""
          />
        </div>
      </div>
    </div>

    <div class="contact_content" id="d">
      <div class="ad_title">开启<span class="jb2">AI游戏新时代</span></div>
      <div class="ad_desc">从创意验证到内容制作，从用户增长到商业化变现，AI Agent 全链路赋能游戏产业。<br/>加入星游聚，与我们一起重新定义游戏开发的未来。</div>
      <div class="lx_btn" @click="showQrCode">
        联系我们
      </div>
      <!-- 优化：点击显示二维码弹层 -->
      <div
        v-if="qrCodeVisible"
        class="qr-code-modal"
        @click.self="qrCodeVisible = false"
      >
        <div class="qr-code-dialog">
          <img
            src="../../assets/img/code.png"
            alt="二维码"
            class="qr-img"
          />
          <div class="qr-label">请扫描上方二维码联系我们</div>
          <button class="close-btn" @click="qrCodeVisible = false">关闭</button>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Banner from "./components/Banner";
import ProductCarousel from "./components/ProductCarousel"; // 引入新组件
import { getAllCertificates, getFooterData } from "@/api/index"; // 引入API方法

export default {
  name: "Home",
  components: {
    Banner, // 轮播图
    ProductCarousel, // 横向商品
  },
  props: {},
  watch: {},
  data() {
    return {
      homeTitle: "",
      homeDescription: "",
      hotlineVisible: false, // 服务支持弹窗
      certificates: [], // 存储证书数据
      qrCodeVisible: false,
      footerData: null,
      hoverAdIndex: null,
      adList: [
        {
          imgNormal: require('../../assets/img/ad1x.png'),
          imgHover: require('../../assets/img/ad1.png'),
          title: '数据驱动决策',
          desc: '实时ROI分析、用户行为洞察、智能风险预警，让数据成为决策的核心依据'
        },
        {
          imgNormal: require('../../assets/img/ad2x.png'),
          imgHover: require('../../assets/img/ad2.png'),
          title: '智能增长引擎',
          desc: 'AI素材创作、自动化投放、一键开户上线，实现用户增长的智能化运营'
        },
        {
          imgNormal: require('../../assets/img/ad3x.png'),
          imgHover: require('../../assets/img/ad3.png'),
          title: '资产价值变现',
          desc: '游戏资产存证、价值评估、快速融资对接，让虚拟资产产生真实价值'
        },
        {
          imgNormal: require('../../assets/img/ad4x.png'),
          imgHover: require('../../assets/img/ad4.png'),
          title: '快速资金支持',
          desc: '融资快速审批、资金即时到位、助力项目腾飞，解决企业资金燃眉之急'
        }
      ],
      comList: [
        {
          img: require('../../assets/img/jg1.png'),
        },
        {
          img: require('../../assets/img/jg2.png'),
        },
        {
          img: require('../../assets/img/jg3.png'),
        },
        {
          img: require('../../assets/img/jg4.png'),
        },
        {
          img: require('../../assets/img/jg5.png'),
        },
        {
          img: require('../../assets/img/jg6.png'),
        },
        {
          img: require('../../assets/img/jg7.png'),
        },
        {
          img: require('../../assets/img/jg8.png'),
        },
        {
          img: require('../../assets/img/jg9.png'),
        },
        {
          img: require('../../assets/img/jg10.png'),
        },

      ],
    };
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    }, 0);
  },
  created() {},
  methods: {
    gourl(url) {
    // 新开一个窗口，跳转第三方地址
    window.open(url, '_blank');
    },
    navigateTo(url) {
      // window.location.href = url;
      this.$router.push(url);
    },
    showHotline() {
      this.hotlineVisible = true;
    },
    copyToClipboard(text) {
      const input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message.success("复制成功");
    },
    async fetchCertificates() {
      try {
        const response = await getAllCertificates();
        this.certificates = response.data;
      } catch (error) {
        console.error("Failed to fetch certificates:", error);
      }
    },
    async fetchHomeData() {
      try {
        const response = await getFooterData();
        // console.log("response", response);
        if (response && response.data) {
          this.homeTitle = response.data[0].homeTitle || "XXXXXXXXXXXXXXXX";
          this.homeDescription =
            response.data[0].homeDescription ||
            "一个XXXXXXXXXX、经典、文化的深度用户";
        }
      } catch (error) {
        console.error("获取首页数据失败:", error);
      }
    },
    // 优化showQrCode方法，显示二维码弹窗
    showQrCode() {
      this.qrCodeVisible = true;
    },
    async fetchFooterData() {
      try {
        const response = await getFooterData();
        if (response && response.data && response.data.length > 0) {
          this.footerData = response.data[0];
        }
      } catch (error) {
        console.error("获取页脚数据失败:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* ...原有样式... */

.qr-code-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2024;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.45);
  display: flex;
  justify-content: center;
  align-items: center;
}
.qr-code-dialog {
  background: #fff;
  border-radius: 18px;
  padding: 36px 34px 22px 34px;
  box-shadow: 0 8px 24px rgba(32,40,80,0.19);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 300px;
  position: relative;
}
.qr-img {
  width: 180px;
  height: 180px;
  object-fit: contain;
  border-radius: 8px;
}
.qr-label {
  margin-top: 18px;
  font-size: 16px;
  color: #464CC5;
  text-align: center;
}
.close-btn {
  margin-top: 22px;
  border: none;
  background: #6366F1;
  color: #fff;
  font-size: 16px;
  border-radius: 8px;
  padding: 8px 22px;
  cursor: pointer;
  outline: none;
}
.close-btn:hover {
  background: #8989ff;
}

.hotline-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hotline-text {
  font-size: 18px;
  /* Increase font size */
  user-select: text;
  /* Make text selectable */
}

.page {
  display: flex;
  flex-direction: column;
  min-height: 100vh; // Ensure the page takes at least the full height of the viewport
  padding: 20px;
  margin-top: 75px; // 添加这一行

  @media (max-width: 768px) {
    padding: 10px;
    margin-top: 60px; // 在移动设备上调整这个值
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
}

.container {
  flex: 1; // Allow the container to grow and fill available space
  margin-bottom: 100px; // Add space between container and footer
}

.introduce {
  margin: 20px 0;
  text-align: center;
}

.center {
  text-align: center;
}

.about-us {
  margin: 40px 0;
  text-align: center;

  h2 {
    font-size: 24px;
    margin-bottom: 20px;
    position: relative;
  }

  h2::after {
    content: "";
    display: block;
    width: 50px;
    height: 2px;
    background: red;
    margin: 10px auto 0;
  }

  p {
    font-size: 16px;
    color: #666;
    margin-bottom: 40px;
  }
}

.features {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  .feature {
    width: 200px;
    text-align: center;
    margin-bottom: 20px;

    .feature-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 10px;
    }

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    p {
      font-size: 14px;
      color: #666;
    }
  }
}

/* 新增样式 */
.info-services {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 20px 0;

  .service {
    width: 200px;
    text-align: center;
    cursor: pointer;
    transition: transform 0.3s;

    &:hover {
      transform: scale(1.05);
    }

    .service-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 10px;
    }

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    p {
      font-size: 14px;
      color: #666;
    }
  }
}

.full-image {
  width: 100%;
  height: 100%;
  object-fit: cover; // 保持图片的宽高比并裁剪以填充容器
}

.scrolling-container {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  position: relative;
}

.scrolling-content {
  display: inline-block;
  animation: scroll 20s linear infinite;
  text-align: center;
  margin: 0 10px;
}

.certificate-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  display: block;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .scrolling-content {
    animation: scroll 10s linear infinite;
  }
}

@keyframes scroll {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}

.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    margin-top: 10px;
    font-size: 14px;
    color: #666;
  }
}


.banners{
	background-image: url('../../assets/img/bg.png');
	height: 1007px;
	background-size: cover;
	margin-top: 74px;
	.banners_content{
		width: 1337px;
		display: flex;
		justify-content: space-between;
		margin-left: 368px;
		.banners_l{
			width: 544px;
			margin-top: 218px;
			.banners_title{
				width: 210px;
				height: 68px;
				font-family: var(--font-xiaoxin);
				font-weight: 400;
				font-size: 70px;
				line-height: 67px;
			  /* 设置渐变背景（从左到右）*/
			  background: linear-gradient(90deg, #6366F1, #CE72ED);
			  /* 将背景裁剪为文字形状 */
			  -webkit-background-clip: text;
			  background-clip: text;
			  /* 隐藏原始文字颜色（显示渐变色） */
			  color: transparent;
			  /* 可选：添加字体样式增强效果 */
			}
			.banners_desc{
				width: 492px;
				height: 144px;
				font-family: var(--font-xiaoxin);
				font-weight: 400;
				font-size: 64px;
				color: #1E293B;
				line-height: 72px;
				letter-spacing: 1px;
				text-align: left;
				margin-top: 16px;
			}
			.banners_desc2{
				width: 545px;
				height: 67px;
				font-family: Source Han Sans, Source Han Sans;
				font-weight: 400;
				font-size: 18px;
				color: #51619F;
				line-height: 33px;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin-top: 25px;
			}
		}
			.banner_z{
				margin-top: 218px;
			}
		.banners_btn{
			width: 316px;
			display: flex;
			justify-content: space-between;
			margin-top: 57px;
			.banners_btn1{
				width: 161px;
				height: 56px;
				background: linear-gradient( 135deg, #6366F1 0%, #8B5CF6 100%);
				box-shadow: 0px 4px 14px 0px rgba(99,102,241,0.35);
				border-radius: 12px 12px 12px 12px;
				font-family: Source Han Sans, Source Han Sans;
				font-weight: 700;
				font-size: 18px;
				color: #FFFFFF;
				line-height: 56px;
				text-align: center;
				cursor: pointer;
			}
			.banners_btn2{
				width: 131px;
				height: 56px;
				border-radius: 12px 12px 12px 12px;
				border: 2px solid #9A9CE8;
				font-family: Source Han Sans, Source Han Sans;
				font-weight: 500;
				font-size: 18px;
				color: #9A9CE8;
				line-height: 56px;
				text-align: center;
				cursor: pointer;
			}
		}	
	}
	
	}
.advantage_content{
	width: 100%;
	height: 636px;
	overflow: hidden;
	.ad_title{
		height: 52px;
		font-family: var(--font-xiaoxin);
		font-weight: 400;
		font-size: 42px;
		color: #1E293B;
		line-height: 52px;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin-top: 90px;
	}
	.ad_desc{
		height: 30px;
		font-family: Inter, Inter;
		font-weight: 400;
		font-size: 16px;
		color: #64748B;
		line-height: 30px;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}
	.ad_list{
		display: flex;
		justify-content: space-between;
		width: 1164px;
		margin:0 auto;
		margin-top: 80px;
		.ad_item{
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 272px;
			height: 259px;
			background: #FFFFFF;
			border-radius: 20px 20px 20px 20px;
			border: 1px solid #E2E8F0;
			padding: 4px 27px 30px;
			cursor: pointer;
			.ad_item_title{
				width: 100%;
				height: 29px;
				font-family: Inter, Inter;
				font-weight: 700;
				font-size: 18px;
				color: #1E293B;
				line-height: 28px;
				text-align: center;
				margin-top: 4px;
			}
			.ad_item_desc{
				width: 218px;
				height: 70px;
				font-family: Source Han Sans, Source Han Sans;
				font-weight: 400;
				font-size: 14px;
				color: #8087A4;
				line-height: 23px;
				text-align: center;
				font-style: normal;
				text-transform: none;
				margin-top: 14px;
			}
		}
		.ad_item:hover{
			background: linear-gradient( 138deg, #F5EFFF 0%, #FFFFFF 100%);
			border: 1px solid #9A9CE8;
		}
	}
}	
	.jb{
		/* 设置渐变背景（从左到右）*/
		background: linear-gradient(90deg, #6366F1, #CE72ED);
		/* 将背景裁剪为文字形状 */
		-webkit-background-clip: text;
		background-clip: text;
		/* 隐藏原始文字颜色（显示渐变色） */
		color: transparent;
		/* 可选：添加字体样式增强效果 */
	}
	.ai_content{
		width: 100%;
		height: 804px;
		overflow: hidden;
		background-image: url('../../assets/img/bg2.png');
		background-size: cover;
		.ad_title{
			height: 52px;
			font-family: var(--font-xiaoxin);
			font-weight: 400;
			font-size: 42px;
			color: #1E293B;
			line-height: 52px;
			text-align: center;
			font-style: normal;
			text-transform: none;
			margin-top: 98px;
		}
		.ad_desc{
			height: 30px;
			font-family: Inter, Inter;
			font-weight: 400;
			font-size: 16px;
			color: #64748B;
			line-height: 30px;
			text-align: center;
			font-style: normal;
			text-transform: none;
		}
		.ai_list{
			display: flex;
			justify-content: space-between;
			width: 1160px;
			margin:0 auto;
			margin-top: 80px;
			.ai_item{
				width: 560px;
				height: 426px;
				border-radius: 24px;
				background: #FFFFFF;
				position: relative;
				cursor: pointer;
				//边框阴影
				box-shadow: 0px 3px 6px 0px rgba(202, 205, 220, 0.66);
				.ai_img{
					width: 560px;
					height: 280px;
					border-radius: 24px 24px 0 0;
				}
				.ai_item_title{
					height: 32px;
					font-family: Source Han Sans, Source Han Sans;
					font-weight: 700;
					font-size: 20px;
					color: #1E293B;
					line-height: 32px;
					text-align: left;
					margin-left: 30px;
					margin-top: 20px;
				}
				.ai_item_desc{
					margin-left: 30px;
					margin-top: 10px;
					width: 504px;
					height: 49px;
					font-family: Source Han Sans, Source Han Sans;
					font-weight: 400;
					font-size: 14px;
					color: #8087A4;
					line-height: 24px;
					text-align: left;
				}
				.gouse{
					position: absolute;
					top: 20px;
					right: 20px;
					width: 96px;
					height: 34px;
					background: linear-gradient( 138deg, rgba(230,217,252,0.78) 0%, rgba(172,176,246,0.78) 100%);
					border-radius: 20px 20px 20px 20px;
					border: 2px solid #9A9CE8;
					text-align: center;
					line-height: 34px;
					font-family: Source Han Sans, Source Han Sans;
					font-weight: 500;
					font-size: 14px;
					color: #464CC5;
					line-height: 30px;
					cursor: pointer;
				}
			}
		}
	}
	.jb2{
		/* 设置渐变背景（从左到右）*/
		background: linear-gradient(90deg, #6366F1, #CE72ED);
		/* 将背景裁剪为文字形状 */
		-webkit-background-clip: text;
		background-clip: text;
		/* 隐藏原始文字颜色（显示渐变色） */
		color: transparent;
		/* 可选：添加字体样式增强效果 */
		margin-left: 6px;
	}
	
	.com_content{
		width: 100%;
		height: 554px;
		overflow: hidden;
		.ad_title{
			height: 52px;
			font-family: var(--font-xiaoxin);
			font-weight: 400;
			font-size: 42px;
			color: #1E293B;
			line-height: 52px;
			text-align: center;
			font-style: normal;
			text-transform: none;
			margin-top: 100px;
		}
		.ad_desc{
			height: 30px;
			font-family: Inter, Inter;
			font-weight: 400;
			font-size: 16px;
			color: #64748B;
			line-height: 30px;
			text-align: center;
			font-style: normal;
			text-transform: none;
		}
		.com_list{
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			width: 1121px;
			margin:0 auto;
			margin-top: 84px;
		}
		.com_item{
			width: 205px;
			height: 67px;
			cursor: pointer;
			margin-bottom: 38px;
		}
		.com_item:hover{
			transform: scale(1.1);
			transition: all 0.3s ease-in-out;
		}
	}
	
	.contact_content{
		width: 100%;
		height: 450px;
		overflow: hidden;
		background-image: url('../../assets/img/bg3.png');
		background-size: cover;
		.ad_title{
			height: 52px;
			font-family: var(--font-xiaoxin);
			font-weight: 400;
			font-size: 42px;
			color: #1E293B;
			line-height: 52px;
			text-align: center;
			font-style: normal;
			text-transform: none;
			margin-top: 98px;
		}
		.ad_desc{
			height: 60px;
			font-family: Inter, Inter;
			font-weight: 400;
			font-size: 16px;
			color: #64748B;
			line-height: 30px;
			text-align: center;
			font-style: normal;
			text-transform: none;
			margin-top: 16px;
		}
		.lx_btn{
			width: 166px;
			height: 56px;
			background: linear-gradient( 135deg, #6366F1 0%, #8B5CF6 100%);
			box-shadow: 0px 4px 14px 0px rgba(99,102,241,0.35);
			border-radius: 12px 12px 12px 12px;
			margin: 0 auto;
			line-height: 56px;
			font-family: Source Han Sans, Source Han Sans;
			font-weight: 700;
			font-size: 16px;
			color: #FFFFFF;
			text-align: center;
			margin-top: 50px;
			cursor: pointer;
		}
	}
	
</style>